<template>
  <div class="chance-list">
    <tab></tab>
    <div class="row">
      <div :class="{'hidden-xs hidden-sm':isShowWeb}">
        <div class="web-index-neck">{{lanType==1?'设立科学碳目标':'Set a Target'}}</div>
        <div class="web-index-font">{{lanType==1?"与 2,000 多名商业领袖⼀起采取雄⼼勃勃的⽓候⾏动。按照此流程设定基于科学的目标，减少您公司的温室⽓体排放，并使您的业务⾯向未来。":"Join over 2, 000 business leaders taking ambitious climate action. Follow this process to set science-based targets, cut your company's greenhouse gas emissions and future-proof your business today."}}</div>
        <div class="web-index-label">
          <div class="index-label-center">
            <div class="label-center-list">
              <a class="center-list-icon" href="#section1" @click="choiceType(1)">1</a>
              <div class="center-list-font">{{lanType==1?'承诺':'Promise'}}</div>
            </div>

            <div class="label-center-list">
              <a class="center-list-icon" href="#section2" @click="choiceType(2)">2</a>
              <div class="center-list-font">{{lanType==1?'开发':'Development'}}</div>
            </div>

            <div class="label-center-list">
              <a class="center-list-icon" href="#section3" @click="choiceType(3)">3</a>
              <div class="center-list-font">{{lanType==1?'提交':'Submit'}}</div>
            </div>

            <div class="label-center-list">
              <a class="center-list-icon" href="#section4" @click="choiceType(4)">4</a>
              <div class="center-list-font">{{lanType==1?'沟通':'Communicate'}}</div>
            </div>

            <div class="label-center-list">
              <a class="center-list-icon" href="#section5" @click="choiceType(5)">5</a>
              <div class="center-list-font">{{lanType==1?'披露':'Disclosure'}}</div>
            </div>
          </div>
        </div>

        <div class="web-index-center">
          <div class="index-center-list" id="section1">
            <div class="center-list-top" @click="choiceType(1)">
              <div class="center-list-left">
                <div class="center-list-icon">1</div>
                <div class="list-left-font">{{lanType==1?'承诺':'Promise'}}</div>
              </div>
              <div class="center-list-right">
                <img src="@/images/xia.png" alt="#" class="list-right-icon"/>
              </div>
            </div>
            <div class="center-list-center" v-if="type==1">
              <div class="list-center-top">
                <div class="center-top-left">
                  <div class="top-left-title">{{lanType==1?'递交科学碳目标承诺书，或者独立验证您现有的目标':'Submit a letter to commit to setting a science-based target, or to have your existing targets independently verified.'}}</div>
                  <div class="top-left-tips">{{lanType==1?'如果您的公司是中小型企业（SME），请跳过此步骤并继续执行步骤3。SBTi将SME定义为一家员工数少于500人的独立的非子公司。':'If your company is a Small or Medium-Sized Enterprise (SME), please skip this step and proceed to step 3. We define an SME as an independent, non-subsidiary company with fewer than 500 employees.'}}</div>

                  <div class="top-left-list">
                    <div class="left-list-li">
                      <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'提交':'Submit either our'}}<a href="//static.wwfchina.org/storage/climatebusinesshub/SBT-Commitment-Letter_V3.0.docx.pdf">{{lanType==1?'标准承诺书':'standard commitment letter'}}</a>{{lanType==1?'或':'or the'}}<a href="//static.wwfchina.org/storage/climatebusinesshub/Business-Ambition-Pledge_V1.4.pdf"></a><a href="//static.wwfchina.org/storage/climatebusinesshub/Business-Ambition-Pledge_V1.4.pdf">{{lanType==1?'1.5°C商业目标承诺书。':'Business Ambition for 1.5°C commitment letter.'}}</a>{{lanType==1?'SBTi鼓励公司选择后一种方案，并尽最大可能地展示自己的气候雄心。':'We encourage companies to choose the latter option and commit to the highest level of ambition possible.'}}</div>
                    </div>

                    <div class="left-list-li">
                      <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'收到承诺书后，SBTi将您的公司认定为“承诺”，并展示在':'Once received, we will recognize your company as "Committed" on our'}}<a href="https://sciencebasedtargets.org/companies-taking-action/">{{lanType==1?'官网':'website'}}</a>{{lanType==1?'及合作伙伴CDP、We Mean Business官网。':'and partner websites CDP and We Mean Business.'}}</div>
                    </div>

                    <div class="left-list-li">
                      <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'如果您签署了1.5°C商业目标承诺书，那么您的承诺也将在':'If you have signed the Business Ambition for 1.5°C letter, your commitment will also be listed by the '}}<a href="https://unfccc.int/climate-action/race-to-zero-campaign">{{lanType==1?'联合国全球契约(UN Global Compact)':'UNGC(UN Global Compact),'}}</a>{{lanType==1?'中列出，并且您将成为Race to Zero的一部分。':' and you will become part of the Race to Zero.'}}</div>
                    </div>

                    <div class="left-list-li">
                      <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'做出承诺后，您的公司将有24个月来完成步骤2-4。':'Once committed, your company has 24 months to complete steps 2-4.'}}</div>
                    </div>
                  </div>
                </div>
                <div class="center-top-right">
                  <img src="http://webadmin.wwfchina.org/storage/uploads/image/2021/01/13/e85d7df86e2d4301750ea4a2428218d9.jpg" alt="#" class="top-right-img"/>
                </div>
              </div>

              <div class="list-center-bottom">
                <div class="center-bottom-top">{{lanType==1?'资源':'Resources'}}</div>
                <div class="center-bottom-list">
                  <a href="//static.wwfchina.org/storage/climatebusinesshub/SBTi-Corporate-Manual-v1.1.pdf" class="bottom-list-li">
                    <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                    <div class="list-li-font">SBTi Corporate Manual, Version 1.0 | April 2020</div>
                  </a>

                  <a href="//static.wwfchina.org/storage/climatebusinesshub/SBT-Commitment-Letter_V3.0.docx.pdf" class="bottom-list-li">
                    <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                    <div class="list-li-font">SBT Commitment Letter, Version 3.0 | July 2021</div>
                  </a>

                  <a href="//static.wwfchina.org/storage/climatebusinesshub/Business-Ambition-Pledge_V1.4.pdf" class="bottom-list-li">
                    <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                    <div class="list-li-font">Business Ambition for 1.5°C Commitment Letter, Version 1.4 | July 2021</div>
                  </a>

                  <a href="//static.wwfchina.org/storage/climatebusinesshub/SBT Target Submission Form and Gudiance_V2.3_CN.pdf" class="bottom-list-li" v-if="lanType==1">
                    <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                    <div class="list-li-font">SBTi目标提交表与指南, 第2.3版｜2018年2月</div>
                  </a>

                  <a href="//static.wwfchina.org/storage/climatebusinesshub/SBT Setting Manual V4_CN.pdf" class="bottom-list-li" v-if="lanType==1">
                    <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                    <div class="list-li-font">科学碳目标设定手册, 第4.0版｜2019年4月</div>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="index-center-list" id="section2">
            <div class="center-list-top" @click="choiceType(2)">
              <div class="center-list-left">
                <div class="center-list-icon">2</div>
                <div class="list-left-font">{{lanType==1?'开发':'Development'}}</div>
              </div>
              <div class="center-list-right">
                <img src="@/images/xia.png" alt="#" class="list-right-icon"/>
              </div>
            </div>
            <div class="center-list-center" v-if="type==2">
              <div class="list-center-top">
                <div class="center-top-left">
                  <div class="top-left-title" v-if="lanType==1"><a href="//static.wwfchina.org/storage/climatebusinesshub/SBTi-criteria.pdf">根据</a>我们<a href="//static.wwfchina.org/storage/climatebusinesshub/SBTi-criteria.pdf">基于科学的标准</a>制定您的目标。</div>
                  <div class="top-left-title" v-if="lanType==2">Develop your target(s) in line with our<a href="//static.wwfchina.org/storage/climatebusinesshub/SBTi-criteria.pdf">science-based criteria.</a></div>

                  <div class="top-left-list">
                    <div class="left-list-li">
                      <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'我们提供全面的指导，以协助您的公司完成此过程。':'We offer comprehensive guidance to assist your company in this process.'}}</div>
                    </div>

                    <div class="left-list-li">
                      <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'我们鼓励公司从':'We encourage companies to begin with an overview of the target development process in the'}} <a href="//static.wwfchina.org/storage/climatebusinesshub/SBTi-How-To-Guide-1.pdf">{{lanType==1?'SBTi操作指南（SBTi How-To Guide,）':'SBTi How-To Guide,'}}</a>{{lanType==1?'中概述 中的目标制定过程，然后再了解':'followed by reviewing the requirements of target setting in the'}}<a href="//static.wwfchina.org/storage/climatebusinesshub/SBTi-criteria.pdf">{{lanType==1?'SBTi标准和建议（SBTi Criteria and Recommendations.）':'SBTi Criteria and Recommendations.'}}</a>{{lanType==1?'中目标设置的要求。为了更深入地了解这些要求，您的公司下一步应是查看目标验证':'To understand these requirements in more depth, companies should then review the'}}<a href="//static.wwfchina.org/storage/climatebusinesshub/target-validation-protocol.pdf">{{lanType==1?'协议（Target Validation Protocol）':'Target Validation Protocol'}}</a>{{lanType==1?'并使用目标':'and use the'}}<a href="//static.wwfchina.org/storage/climatebusinesshub/SBT-Tool-v1.2.1.xlsx">{{lanType==1?'设置工具（SBT Setting Tool）':'target setting tool '}}</a>{{lanType==1?'开始制定目标。':'to begin developing targets.'}}</div>
                    </div>

                    <div class="left-list-li">
                      <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'一些部门也有':'Some sectors also have '}}<a href="https://sciencebasedtargets.org/sectors">{{lanType==1?'针对特定部门的指导和要求':'sector-specific guidance and requirements'}}</a>。</div>
                    </div>

                    <div class="left-list-li">
                      <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'您的公司有24个月的时间来完成签署':'You have 24 months from signing your '}}<a href="https://sciencebasedtargets.org/resources/legacy/2018/12/Protocol-to-manage-expired-commitments.pdf">{{lanType==1?'承诺书':'commitment letter'}}</a>{{lanType==1?'之后的开发、验证和发表目标。':' to get your target developed, validated and published.'}}</div>
                    </div>
                  </div>
                </div>
                <div class="center-top-right">
                  <img src="http://webadmin.wwfchina.org/storage/uploads/image/2021/01/13/588080eb13a08f42fcb02327e79d16a4.jpg" alt="#" class="top-right-img"/>
                </div>
              </div>

              <div class="list-center-bottom">
                <div class="center-bottom-top">{{lanType==1?'资源':'Resources'}}</div>
                <div class="center-bottom-list">
                  <a href="//static.wwfchina.org/storage/climatebusinesshub/SBTi-How-To-Guide-1.pdf" class="bottom-list-li">
                    <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                    <div class="list-li-font">SBTi How-To Guide, Version 1.0 | April 2021</div>
                  </a>
                  <a href="//static.wwfchina.org/storage/climatebusinesshub/SBTi-criteria.pdf" class="bottom-list-li">
                    <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                    <div class="list-li-font">SBTi Criteria and Recommendations, Version 4.2 | April 2021</div>
                  </a>
                  <a href="//static.wwfchina.org/storage/climatebusinesshub/SBT-Tool-v1.2.1.xlsx" class="bottom-list-li">
                    <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                    <div class="list-li-font">Target Validation Protocol, Version 2.1 | April 2021</div>
                  </a>
                  <a href="//static.wwfchina.org/storage/climatebusinesshub/target-validation-protocol.pdf" class="bottom-list-li">
                    <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                    <div class="list-li-font">SBT Setting Tool, Version 1.2.1</div>
                  </a>
                  <a href="//static.wwfchina.org/storage/climatebusinesshub/科学碳目标设定工具第1.1版.pdf" class="bottom-list-li">
                    <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                    <div class="list-li-font">科学碳目标设定工具 第1.1版</div>
                  </a>
                  <a href="//static.wwfchina.org/storage/climatebusinesshub/设定科学碳目标的根据第1.0版2019年4月.pdf" class="bottom-list-li">
                    <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                    <div class="list-li-font">设定科学碳目标的根据 第1.0版2019年4月</div>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="index-center-list" id="section3">
            <div class="center-list-top" @click="choiceType(3)">
              <div class="center-list-left">
                <div class="center-list-icon">3</div>
                <div class="list-left-font">{{lanType==1?'提交':'Submit'}}</div>
              </div>
              <div class="center-list-right">
                <img src="@/images/xia.png" alt="#" class="list-right-icon"/>
              </div>
            </div>
            <div class="center-list-center" v-if="type==3">
              <div class="list-center-top">
                <div class="center-top-left">
                  <div class="top-left-title">{{lanType==1?'提交目标来进行验证':'Submit the target for verification'}}</div>

                  <div class="top-left-list">
                    <div class="left-list-li">
                      <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'提交完整的':'Submit a completed'}}<a href="//static.wwfchina.org/storage/climatebusinesshub/target_submission_form_july_2021-Final.docx">{{lanType==1?'目标提交表格':' target submission form'}}</a>{{lanType==1?'（或':'(or the equivalent for'}}<a href="//static.wwfchina.org/storage/climatebusinesshub/SBT-SME-Target-Setting-Letter.pdf">{{lanType==1?'SME、':' SMEs*'}}</a><a href="//static.wwfchina.org/storage/climatebusinesshub/Financial-institution-SBTi-target-submission-form_pilot-version_1102-1.docx">{{lanType==1?'金融机构':'  financial institutions'}}</a>{{lanType==1?'相应的':').'}}表格{{lanType==1?'）。':''}}</div>
                    </div>

                    <div class="left-list-li">
                      <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font" v-if="lanType==1">为了避免延误，我们建议您认真检查可用的参考材料并且清楚、准确的填写表格。</div>
                      <div class="list-li-font" v-if="lanType==2">To avoid delays, we encourage you to review the <a href="https://sciencebasedtargets.org/resources">available resources carefully</a> and complete the form clearly and accurately.</div>
                    </div>

                    <div class="left-list-li">
                      <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'SBTi的技术专家团队将审核您的提交内容，并根据基于科学的标准对其进行验证，并通过深入的交流反馈达成决定。':'Our team of technical experts will review your submission, validate it against our science-based criteria and communicate their decision with in-depth feedback.'}}</div>
                    </div>

                    <div class="left-list-li">
                      <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'目标验证费用为4950美元（税前），SME企业的目标验证费为1000美元（税前）。在某些情况下，SBTi 将免除总部位于发展中国家的企业的目标验证费':'The target validation service costs USD 4,950** (+ applicable VAT) or USD 1,000 (+ applicable VAT) for SMEs. In some cases, we may'}}<a href="https://sciencebasedtargets.org/faqs#can-the-target-validation-fee-be-waived">{{lanType==1?'验证费':' waive this fee'}}</a>{{lanType==1?'。':'for companies headquartered in developing countries and economies in transition.'}}</div>
                    </div>

                    <div class="top-left-tips">{{lanType==1?'*要符合':'*To be eligible for the'}}<a href="//static.wwfchina.org/storage/climatebusinesshub/faqs-for-smes.pdf">{{lanType==1?'SME目标设定路线的资格，':'streamlined SME target-setting route,'}}</a>{{lanType==1?'您的公司必须是独立的，非子公司且员工人数少于500名。如有更多关于SME的问题，':'your company must be independent, non-subsidiary and with fewer than 500 employees. This is the only option available to SMEs.'}}<a href="//static.wwfchina.org/storage/climatebusinesshub/faqs-for-smes.pdf">{{lanType==1?'请查看SME常见问题解答。':'View our SME FAQs.'}}</a></div>

                    <div class="top-left-tips">{{lanType==1?'**验证费包括最多两次目标评估。后续重新提交每份的费用为2490美元（税前）。':'**The validation fee includes up to two target assessments. Subsequent resubmissions cost USD 2490 (+ applicable VAT) each.'}}</div>

                    <div class="top-left-title mt">{{lanType==1?'升级目标':'Upgrade your target'}}</div>

                    <div class="top-left-label"><a href="//static.wwfchina.org/storage/climatebusinesshub/Target_Ambition_Update_Form-1.1-edits-final.docx">{{lanType==1?'填Target Ambition Update Form，':'Complete this form '}}</a>{{lanType==1?'以将您现有的基于科学的目标自愿更新为1.5°C或低于2°C。':'to voluntarily update your existing science-based target to a 1.5°C or well-below 2°C pathway.'}}</div>
                  </div>
                </div>
                <div class="center-top-right">
                  <img src="http://webadmin.wwfchina.org/storage/uploads/image/2021/01/13/588080eb13a08f42fcb02327e79d16a4.jpg" alt="#" class="top-right-img"/>
                </div>
              </div>

              <div class="list-center-bottom">
                <div class="center-bottom-top">{{lanType==1?'资源':'Resources'}}</div>
                <div class="center-bottom-list">
                  <a href="//static.wwfchina.org/storage/climatebusinesshub/target_submission_form_july_2021-Final.docx" class="bottom-list-li">
                    <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                    <div class="list-li-font">Target submission form July 2021</div>
                  </a>

                  <a href="//static.wwfchina.org/storage/climatebusinesshub/SBT-SME-Target-Setting-Letter.pdf" class="bottom-list-li">
                    <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                    <div class="list-li-font">SBT SME Target Setting Letter</div>
                  </a>

                  <a href="//static.wwfchina.org/storage/climatebusinesshub/Target_Ambition_Update_Form-1.1-edits-final.docx" class="bottom-list-li">
                    <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                    <div class="list-li-font">Target Ambition Update Form</div>
                  </a>

                  <a href="//static.wwfchina.org/storage/climatebusinesshub/Financial-institution-SBTi-target-submission-form_pilot-version_1102-1.docx" class="bottom-list-li">
                    <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                    <div class="list-li-font">SBTi Target Submission Form and Guidance for Financial Institutions - Pilot Version</div>
                  </a>

                  <a href="//static.wwfchina.org/storage/climatebusinesshub/目标审核协定TWG-PRO-002第1.0版2019年4月.pdf" class="bottom-list-li">
                    <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                    <div class="list-li-font">目标审核协定 第1.0版2019年4月</div>
                  </a>

                </div>
              </div>
            </div>
          </div>

          <div class="index-center-list" id="section4">
            <div class="center-list-top" @click="choiceType(4)">
              <div class="center-list-left">
                <div class="center-list-icon">4</div>
                <div class="list-left-font">{{lanType==1?'沟通':'Communicate'}}</div>
              </div>
              <div class="center-list-right">
                <img src="@/images/xia.png" alt="#" class="list-right-icon"/>
              </div>
            </div>
            <div class="center-list-center" v-if="type==4">
              <div class="list-center-top">
                <div class="center-top-left">
                  <div class="top-left-title">{{lanType==1?'宣布目标':'Announce goals'}}</div>

                  <div class="top-left-list">
                    <div class="left-list-li">
                      <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'一旦SBTi批准了您提交的目标，您的公司名称将被发布在其':'Once we have approved your target, we will publish it on our'}}<a href="https://sciencebasedtargets.org/companies-taking-action/">{{lanType==1?'官方网站':' Companies taking action page'}}</a>{{lanType==1?'和':'and'}}<a href="https://sciencebasedtargets.org/about-us/partners">{{lanType==1?'合作伙伴':'partner'}}</a>{{lanType==1?'网站上。':'websites.'}}</div>
                    </div>

                    <div class="left-list-li">
                      <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'除非另有说明，否则SBTi会在批准后的一个月内发布目标。您的目标必须在批准后的六个月内公开，否则将需要重新验证以确保其符合最新的基于科学的标准。':'We publish targets one month after approval, unless otherwise instructed. Your target must be made public within six months of approval, or it will require revalidation to ensure it is in line with the latest science-based criteria.'}}</div>
                    </div>

                    <div class="left-list-li">
                      <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'您的公司将收到一个欢迎信息包，其中包含有关如何传达目标的建议。':'Your company will receive a welcome pack with advice on how to communicate your new target.'}}</div>
                    </div>
                  </div>
                </div>
                <div class="center-top-right">
                  <img src="http://webadmin.wwfchina.org/storage/uploads/image/2021/01/13/aa811c472b8b6242be86214ee2287945.jpg" alt="#" class="top-right-img"/>
                </div>
              </div>
            </div>
          </div>

          <div class="index-center-list" id="section5">
            <div class="center-list-top" @click="choiceType(5)">
              <div class="center-list-left">
                <div class="center-list-icon">5</div>
                <div class="list-left-font">{{lanType==1?'披露':'Disclosure'}}</div>
              </div>
              <div class="center-list-right">
                <img src="@/images/xia.png" alt="#" class="list-right-icon"/>
              </div>
            </div>
            <div class="center-list-center" v-if="type==5">
              <div class="list-center-top">
                <div class="center-top-left">
                  <div class="top-left-title">{{lanType==1?'披露您的进度':'Disclosure progress'}}</div>

                  <div class="top-left-list">
                    <div class="left-list-li">
                      <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'您公司的目标被批准后，应每年披露公司的排放量，并监控实现目标的进度。':"Following approval, you should disclose your companies' emissions annually and monitor progress on reaching your target."}}</div>
                    </div>

                    <div class="left-list-li">
                      <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'建议您公司的披露途径':'Recommendations for reporting include'}}<a href="http://cdp.net/">{{lanType==1?'包括CDP、':'disclosure through CDP,'}}</a>{{lanType==1?'年度报告、可持续发展报告和贵公司网站。':'annual reports, sustainability reports and your company’s website.'}}</div>
                    </div>
                  </div>
                </div>
                <div class="center-top-right">
                  <img src="http://webadmin.wwfchina.org/storage/uploads/image/2021/01/13/02ad709d9e5ec57b65036b91729bc078.jpg" alt="#" class="top-right-img"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="hidden-md hidden-lg">
        <div class="phone-index-neck">{{lanType==1?'项目介绍':'Climate Solvers'}}</div>
        <div class="phone-index-font">{{lanType==1?"与 1,000 多名商业领袖一起采取雄心勃勃的气候行动。按照此流程设定基于科学的目标，减少您公司的温室气体排放，并使您的业务面向未来。":"Ambitious climate action with more than 1000 business leaders. Follow this process to set science based goals to reduce your company's greenhouse gas emissions and to orient your business to the future."}}</div>

        <div class="index-label-center phone-label-center">
          <div class="label-center-list">
            <a class="center-list-icon" href="#phoneSection1" @click="choiceType(1)">1</a>
          </div>

          <div class="label-center-list">
            <a class="center-list-icon" href="#phoneSection2" @click="choiceType(2)">2</a>
          </div>

          <div class="label-center-list">
            <a class="center-list-icon" href="#phoneSection3" @click="choiceType(3)">3</a>
          </div>

          <div class="label-center-list">
            <a class="center-list-icon" href="#phoneSection4" @click="choiceType(4)">4</a>
          </div>

          <div class="label-center-list">
            <a class="center-list-icon" href="#phoneSection5" @click="choiceType(5)">5</a>
          </div>
        </div>

        <div class="web-index-label">

          <div class="web-index-center" style="padding:1rem 0.5rem;">
            <div class="index-center-list phone-center-list" id="phoneSection1">
              <div class="center-list-top phone-list-left" @click="choiceType(1)">
                <div class="center-list-left">
                  <div class="center-list-icon">1</div>
                  <div class="list-left-font phone-left-font">{{lanType==1?'承诺':'Promise'}}</div>
                </div>
                <div class="center-list-right">
                  <img src="@/images/xia.png" alt="#" class="list-right-icon phone-right-icon"/>
                </div>
              </div>
              <div class="center-list-center" v-if="type==1">
                <div class="list-center-top">
                  <div class="center-top-left">
                    <div class="top-left-title phone-left-title">{{lanType==1?'递交科学碳目标承诺书，或者独立验证您现有的目标':'Submit a letter to commit to setting a science-based target, or to have your existing targets independently verified.'}}</div>
                    <div class="top-left-tips phone-left-title phone-list-li">{{lanType==1?'如果您的公司是中小型企业（SME），请跳过此步骤并继续执行步骤3。SBTi将SME定义为一家员工数少于500人的独立的非子公司。':'If your company is a Small or Medium-Sized Enterprise (SME), please skip this step and proceed to step 3. We define an SME as an independent, non-subsidiary company with fewer than 500 employees.'}}</div>

                    <div class="top-left-list">
                      <div class="left-list-li phone-list-li">
                        <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                        <div class="list-li-font phone-left-title">{{lanType==1?'提交':'Submit either our'}}<a href="https://sciencebasedtargets.org/resources/files/SBT-Commitment-Letter.pdf">{{lanType==1?'标准承诺书':'standard commitment letter'}}</a>{{lanType==1?'或':'or the'}}<a href="https://sciencebasedtargets.org/resources/files/Business-Ambition-Pledge.pdf"></a><a href="https://sciencebasedtargets.org/resources/files/Business-Ambition-Pledge.pdf">{{lanType==1?'1.5°C商业目标承诺书。':'Business Ambition for 1.5°C commitment letter.'}}</a>{{lanType==1?'SBTi鼓励公司选择后一种方案，并尽最大可能地展示自己的气候雄心。':'We encourage companies to choose the latter option and commit to the highest level of ambition possible.'}}</div>
                      </div>

                      <div class="left-list-li phone-list-li">
                        <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'收到承诺书后，SBTi将您的公司认定为“承诺”，并展示在':'Once received, we will recognize your company as "Committed" on our'}}<a href="https://sciencebasedtargets.org/companies-taking-action/">{{lanType==1?'官网':'website'}}</a>{{lanType==1?'及合作伙伴CDP、We Mean Business官网。':'and partner websites CDP and We Mean Business.'}}</div>
                      </div>

                      <div class="left-list-li phone-list-li">
                        <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'如果您签署了1.5°C商业目标承诺书，那么您的承诺也将在':'If you have signed the Business Ambition for 1.5°C letter, your commitment will also be listed by the '}}<a href="https://unfccc.int/climate-action/race-to-zero-campaign">{{lanType==1?'联合国全球契约(UN Global Compact)':'UNGC(UN Global Compact),'}}</a>{{lanType==1?'中列出，并且您将成为Race to Zero的一部分。':' and you will become part of the Race to Zero.'}}</div>
                      </div>

                      <div class="left-list-li phone-list-li">
                        <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                        <div class="list-li-font phone-left-title">{{lanType==1?'做出承诺后，您的公司将有24个月来完成步骤2-4。':'Once committed, your company has 24 months to complete steps 2-4.'}}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="center-top-right phone-top-right">
                  <img src="http://webadmin.wwfchina.org/storage/uploads/image/2021/01/13/e85d7df86e2d4301750ea4a2428218d9.jpg" alt="#" class="top-right-img"/>
                </div>

                <div class="list-center-bottom">
                  <div class="center-bottom-top phone-left-title phone-left-height">{{lanType==1?'资源':'Resources'}}</div>
                  <div class="center-bottom-list">
                    <a href="//static.wwfchina.org/storage/climatebusinesshub/SBTi-Corporate-Manual-v1.1.pdf" class="bottom-list-li phone-list-li">
                      <img src="@/images/xia.svg" alt="#" class="list-li-img phone-li-img"/>
                      <div class="list-li-font phone-left-title">SBTi Corporate Manual, Version 1.0 | April 2020</div>
                    </a>

                    <a href="//static.wwfchina.org/storage/climatebusinesshub/SBT-Commitment-Letter_V3.0.docx.pdf" class="bottom-list-li phone-list-li">
                      <img src="@/images/xia.svg" alt="#" class="list-li-img phone-li-img"/>
                      <div class="list-li-font phone-left-title">SBT Commitment Letter, Version 3.0 | July 2021</div>
                    </a>

                    <a href="//static.wwfchina.org/storage/climatebusinesshub/Business-Ambition-Pledge_V1.4.pdf" class="bottom-list-li phone-list-li" v-if="lanType==1">
                      <img src="@/images/xia.svg" alt="#" class="list-li-img phone-li-img"/>
                      <div class="list-li-font phone-left-title">Business Ambition for 1.5°C Commitment Letter, Version 1.4 | July 2021</div>
                    </a>

                    <a href="//static.wwfchina.org/storage/climatebusinesshub/SBT Target Submission Form and Gudiance_V2.3_CN.pdf" class="bottom-list-li phone-list-li">
                      <img src="@/images/xia.svg" alt="#" class="list-li-img phone-li-img"/>
                      <div class="list-li-font phone-left-title">SBTi目标提交表与指南, 第2.3版｜2018年2月</div>
                    </a>

                    <a href="//static.wwfchina.org/storage/climatebusinesshub/SBT Setting Manual V4_CN.pdf" class="bottom-list-li phone-list-li" v-if="lanType==1">
                      <img src="@/images/xia.svg" alt="#" class="list-li-img phone-li-img"/>
                      <div class="list-li-font phone-left-title">科学碳目标设定手册, 第4.0版｜2019年4月</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="index-center-list phone-center-list" id="phoneSection2">
              <div class="center-list-top phone-list-left" @click="choiceType(2)">
                <div class="center-list-left">
                  <div class="center-list-icon">2</div>
                  <div class="list-left-font phone-left-font">{{lanType==1?'开发':'Development'}}</div>
                </div>
                <div class="center-list-right">
                  <img src="@/images/xia.png" alt="#" class="list-right-icon phone-right-icon"/>
                </div>
              </div>
              <div class="center-list-center" v-if="type==2">
                <div class="list-center-top">
                  <div class="center-top-left">
                    <div class="top-left-title phone-left-title" v-if="lanType==1"><a href="https://sciencebasedtargets.org/resources/files/SBTi-criteria.pdf">根据</a>我们<a href="https://sciencebasedtargets.org/wp-content/uploads/2019/03/SBTi-criteria.pdf">基于科学的标准</a>制定您的目标。</div>
                    <div class="top-left-title phone-left-title" v-if="lanType==2">Develop your target(s) in line with our<a href="https://sciencebasedtargets.org/wp-content/uploads/2019/03/SBTi-criteria.pdf">science-based criteria.</a></div>

                    <div class="top-left-list">
                      <div class="left-list-li phone-list-li">
                        <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                        <div class="list-li-font phone-left-title">{{lanType==1?'我们提供全面的指导，以协助您的公司完成此过程。':'We offer comprehensive guidance to assist your company in this process.'}}</div>
                      </div>

                      <div class="left-list-li phone-list-li">
                        <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'我们鼓励公司从':'We encourage companies to begin with an overview of the target development process in the'}} <a href="//static.wwfchina.org/storage/climatebusinesshub/SBTi-How-To-Guide-1.pdf">{{lanType==1?'SBTi操作指南（SBTi How-To Guide,）':'SBTi How-To Guide,'}}</a>{{lanType==1?'中概述 中的目标制定过程，然后再了解':'followed by reviewing the requirements of target setting in the'}}<a href="//static.wwfchina.org/storage/climatebusinesshub/SBTi-criteria.pdf">{{lanType==1?'SBTi标准和建议（SBTi Criteria and Recommendations.）':'SBTi Criteria and Recommendations.'}}</a>{{lanType==1?'中目标设置的要求。为了更深入地了解这些要求，您的公司下一步应是查看目标验证':'To understand these requirements in more depth, companies should then review the'}}<a href="//static.wwfchina.org/storage/climatebusinesshub/target-validation-protocol.pdf">{{lanType==1?'协议（Target Validation Protocol）':'Target Validation Protocol'}}</a>{{lanType==1?'并使用目标':'and use the'}}<a href="//static.wwfchina.org/storage/climatebusinesshub/SBT-Tool-v1.2.1.xlsx">{{lanType==1?'设置工具（SBT Setting Tool）':'target setting tool '}}</a>{{lanType==1?'开始制定目标。':'to begin developing targets.'}}</div>
                      </div>

                      <div class="left-list-li phone-list-li">
                        <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'一些部门也有':'Some sectors also have '}}<a href="https://sciencebasedtargets.org/sectors">{{lanType==1?'针对特定部门的指导和要求':'sector-specific guidance and requirements'}}</a>。</div>
                      </div>

                      <div class="left-list-li phone-list-li">
                        <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                        <div class="list-li-font phone-left-title">{{lanType==1?'您的公司有24个月的时间来完成签署':'You have'}}<a href="https://sciencebasedtargets.org/resources/legacy/2018/12/Protocol-to-manage-expired-commitments.pdf">{{lanType==1?'承诺书':'24 months '}}</a>{{lanType==1?'之后的开发、验证和发表目标。':'from signing your commitment letter to get your target developed, validated and published.'}}</div>
                      </div>
                    </div>
                  </div>
                  
                </div>

                <div class="center-top-right phone-top-right">
                  <img src="http://webadmin.wwfchina.org/storage/uploads/image/2021/01/13/588080eb13a08f42fcb02327e79d16a4.jpg" alt="#" class="top-right-img"/>
                </div>

                <div class="list-center-bottom">
                  <div class="center-bottom-top phone-left-title phone-left-height">{{lanType==1?'资源':'Resources'}}</div>
                  <div class="center-bottom-list">
                    <a href="//static.wwfchina.org/storage/climatebusinesshub/SBTi-How-To-Guide-1.pdf" class="bottom-list-li phone-list-li">
                      <img src="@/images/xia.svg" alt="#" class="list-li-img phone-li-img"/>
                      <div class="list-li-font phone-left-title">SBTi How-To Guide, Version 1.0 | April 2021</div>
                    </a>

                    <a href="//static.wwfchina.org/storage/climatebusinesshub/SBTi-criteria.pdf" class="bottom-list-li phone-list-li">
                      <img src="@/images/xia.svg" alt="#" class="list-li-img phone-li-img"/>
                      <div class="list-li-font phone-left-title">SBTi Criteria and Recommendations, Version 4.2 | April 2021</div>
                    </a>

                    <a href="//static.wwfchina.org/storage/climatebusinesshub/SBT-Tool-v1.2.1.xlsx" class="bottom-list-li phone-list-li">
                      <img src="@/images/xia.svg" alt="#" class="list-li-img phone-li-img"/>
                      <div class="list-li-font phone-left-title">Target Validation Protocol, Version 2.1 | April 2021</div>
                    </a>

                    <a href="//static.wwfchina.org/storage/climatebusinesshub/target-validation-protocol.pdf" class="bottom-list-li phone-list-li">
                      <img src="@/images/xia.svg" alt="#" class="list-li-img phone-li-img"/>
                      <div class="list-li-font phone-left-title">SBT Setting Tool, Version 1.2.1</div>
                    </a>

                    <a href="//static.wwfchina.org/storage/climatebusinesshub/科学碳目标设定工具第1.1版.pdf" class="bottom-list-li phone-list-li">
                      <img src="@/images/xia.svg" alt="#" class="list-li-img phone-li-img"/>
                      <div class="list-li-font phone-left-title">科学碳目标设定工具 第1.1版</div>
                    </a>

                    <a href="//static.wwfchina.org/storage/climatebusinesshub/设定科学碳目标的根据第1.0版2019年4月.pdf" class="bottom-list-li phone-list-li">
                      <img src="@/images/connect.svg" alt="#" class="list-li-img phone-li-img"/>
                      <div class="list-li-font phone-left-title">设定科学碳目标的根据 第1.0版2019年4月</div>
                    </a>

                    <!-- <a href="https://sciencebasedtargets.org/faqs#what-guidance-do-you-offer-for-setting-science-based-targets" class="bottom-list-li phone-list-li">
                      <img src="@/images/connect.svg" alt="#" class="list-li-img phone-li-img"/>
                      <div class="list-li-font phone-left-title">查看设定目标的常见问题</div>
                    </a> -->
                  </div>
                </div>
              </div>
            </div>

            <div class="index-center-list phone-center-list" id="phoneSection3">
              <div class="center-list-top phone-list-left" @click="choiceType(3)">
                <div class="center-list-left">
                  <div class="center-list-icon">3</div>
                  <div class="list-left-font phone-left-font">{{lanType==1?'提交':'Submit'}}</div>
                </div>
                <div class="center-list-right">
                  <img src="@/images/xia.png" alt="#" class="list-right-icon phone-right-icon"/>
                </div>
              </div>
              <div class="center-list-center" v-if="type==3">
                <div class="list-center-top">
                  <div class="center-top-left">
                    <div class="top-left-title phone-left-title">{{lanType==1?'提交目标来进行验证':'Submit the target for verification'}}</div>

                    <div class="top-left-list">
                      <div class="left-list-li phone-list-li">
                        <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'提交完整的':'Submit a completed'}}<a href="//static.wwfchina.org/storage/climatebusinesshub/target_submission_form_july_2021-Final.docx">{{lanType==1?'目标提交表格':' target submission form'}}</a>{{lanType==1?'（或':'(or the equivalent for'}}<a href="//static.wwfchina.org/storage/climatebusinesshub/SBT-SME-Target-Setting-Letter.pdf">{{lanType==1?'SME、':' SMEs*'}}</a><a href="//static.wwfchina.org/storage/climatebusinesshub/Financial-institution-SBTi-target-submission-form_pilot-version_1102-1.docx">{{lanType==1?'金融机构':'  financial institutions'}}</a>{{lanType==1?'相应的':').'}}表格{{lanType==1?'）。':''}}</div>
                      </div>

                      <div class="left-list-li phone-list-li">
                        <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font" v-if="lanType==1">为了避免延误，我们建议您认真检查可用的参考材料并且清楚、准确的填写表格。</div>
                      <div class="list-li-font" v-if="lanType==2">To avoid delays, we encourage you to review the <a href="https://sciencebasedtargets.org/resources">available resources carefully</a> and complete the form clearly and accurately.</div>
                      </div>

                      <div class="left-list-li phone-list-li">
                        <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'SBTi的技术专家团队将审核您的提交内容，并根据基于科学的标准对其进行验证，并通过深入的交流反馈达成决定。':'Our team of technical experts will review your submission, validate it against our science-based criteria and communicate their decision with in-depth feedback.'}}</div>
                      </div>

                      <div class="left-list-li phone-list-li">
                        <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                      <div class="list-li-font">{{lanType==1?'目标验证费用为4950美元（税前），SME企业的目标验证费为1000美元（税前）。在某些情况下，SBTi 将免除总部位于发展中国家的企业的目标验证费':'The target validation service costs USD 4,950** (+ applicable VAT) or USD 1,000 (+ applicable VAT) for SMEs. In some cases, we may'}}<a href="https://sciencebasedtargets.org/faqs#can-the-target-validation-fee-be-waived">{{lanType==1?'验证费':' waive this fee'}}</a>{{lanType==1?'。':'for companies headquartered in developing countries and economies in transition.'}}</div>
                      </div>

                      <div class="top-left-tips phone-list-li phone-left-title">{{lanType==1?'*要符合':'*To be eligible for the'}}<a href="//static.wwfchina.org/storage/climatebusinesshub/faqs-for-smes.pdf">{{lanType==1?'SME目标设定路线的资格，':'streamlined SME target-setting route,'}}</a>{{lanType==1?'您的公司必须是独立的，非子公司且员工人数少于500名。如有更多关于SME的问题，':'your company must be independent, non-subsidiary and with fewer than 500 employees. This is the only option available to SMEs.'}}<a href="//static.wwfchina.org/storage/climatebusinesshub/faqs-for-smes.pdf">{{lanType==1?'请查看SME常见问题解答。':'View our SME FAQs.'}}</a></div>

                      <div class="top-left-tips phone-list-li phone-left-title">{{lanType==1?'**验证费包括最多两次目标评估。后续重新提交每份的费用为2490美元（税前）。':'**The validation fee includes up to two target assessments. Subsequent resubmissions cost USD 2490 (+ applicable VAT) each.'}}</div>

                    <div class="top-left-title mt">{{lanType==1?'升级目标':'Upgrade your target'}}</div>

                      <div class="top-left-title phone-list-li phone-left-title">{{lanType==1?'升级目标':'Upgrade your target'}}</div>

                      <div class="top-left-label phone-list-li phone-left-title"><a href="//static.wwfchina.org/storage/climatebusinesshub/Target_Ambition_Update_Form-1.1-edits-final.docx">{{lanType==1?'填Target Ambition Update Form，':'Complete this form '}}</a>{{lanType==1?'以将您现有的基于科学的目标自愿更新为1.5°C或低于2°C。':'to voluntarily update your existing science-based target to a 1.5°C or well-below 2°C pathway.'}}</div>
                    </div>
                  </div>
                </div>
                <div class="center-top-right phone-top-right">
                  <img src="http://webadmin.wwfchina.org/storage/uploads/image/2021/01/13/588080eb13a08f42fcb02327e79d16a4.jpg" alt="#" class="top-right-img"/>
                </div>

                <div class="list-center-bottom">
                  <div class="center-bottom-top phone-left-title phone-left-height">{{lanType==1?'资源':'Resources'}}</div>
                  <div class="center-bottom-list">
                    <a href="//static.wwfchina.org/storage/climatebusinesshub/target_submission_form_july_2021-Final.docx" class="bottom-list-li phone-list-li">
                      <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                      <div class="list-li-font phone-left-title">Target submission form July 2021</div>
                    </a>

                    <a href="//static.wwfchina.org/storage/climatebusinesshub/SBT-SME-Target-Setting-Letter.pdf" class="bottom-list-li phone-list-li">
                      <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                      <div class="list-li-font phone-left-title">SBT SME Target Setting Letter</div>
                    </a>

                    <a href="//static.wwfchina.org/storage/climatebusinesshub/Target_Ambition_Update_Form-1.1-edits-final.docx" class="bottom-list-li phone-list-li">
                      <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                      <div class="list-li-font phone-left-title">Target Ambition Update Form</div>
                    </a>

                    <a href="//static.wwfchina.org/storage/climatebusinesshub/Financial-institution-SBTi-target-submission-form_pilot-version_1102-1.docx" class="bottom-list-li phone-list-li">
                      <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                      <div class="list-li-font phone-left-title">SBTi Target Submission Form and Guidance for Financial Institutions - Pilot Version</div>
                    </a>

                    <a href="//static.wwfchina.org/storage/climatebusinesshub/目标审核协定TWG-PRO-002第1.0版2019年4月.pdf" class="bottom-list-li phone-list-li">
                    <img src="@/images/xia.svg" alt="#" class="list-li-img"/>
                    <div class="list-li-font phone-left-title">目标审核协定 第1.0版2019年4月</div>
                  </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="index-center-list phone-center-list" id="phoneSection4">
              <div class="center-list-top phone-list-left" @click="choiceType(4)">
                <div class="center-list-left">
                  <div class="center-list-icon">4</div>
                  <div class="list-left-font phone-left-font">{{lanType==1?'沟通':'Communicate'}}</div>
                </div>
                <div class="center-list-right">
                  <img src="@/images/xia.png" alt="#" class="list-right-icon phone-right-icon"/>
                </div>
              </div>
              <div class="center-list-center" v-if="type==4">
                <div class="list-center-top">
                  <div class="center-top-left">
                    <div class="top-left-title phone-left-title">{{lanType==1?'宣布目标':'Announce goals'}}</div>

                    <div class="top-left-list">
                      <div class="left-list-li phone-list-li">
                        <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                        <div class="list-li-font phone-left-title">{{lanType==1?'一旦SBTi批准了您提交的目标，您的公司名称将被发布在其':'Once we have approved your target, we will publish it on our'}}<a href="https://sciencebasedtargets.org/companies-taking-action/">{{lanType==1?'官方网站':' Companies taking action page'}}</a>{{lanType==1?'和':'and'}}<a href="https://sciencebasedtargets.org/about-us/partners">{{lanType==1?'合作伙伴':'partner'}}</a>{{lanType==1?'网站上。':'websites.'}}</div>
                      </div>

                      <div class="left-list-li phone-list-li">
                        <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                        <div class="list-li-font phone-left-title">{{lanType==1?'除非另有说明，否则SBTi会在批准后的一个月内发布目标。您的目标必须在批准后的六个月内公开，否则将需要重新验证以确保其符合最新的基于科学的标准。':'We publish targets one month after approval, unless otherwise instructed. Your target must be made public within six months of approval, or it will require revalidation to ensure it is in line with the latest science-based criteria.'}}</div>
                      </div>

                      <div class="left-list-li phone-list-li">
                        <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                        <div class="list-li-font phone-left-title">{{lanType==1?'您的公司将收到一个欢迎信息包，其中包含有关如何传达目标的建议。':'Your company will receive a welcome pack with advice on how to communicate your new target.'}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="center-top-right phone-top-right">
                  <img src="http://webadmin.wwfchina.org/storage/uploads/image/2021/01/13/aa811c472b8b6242be86214ee2287945.jpg" alt="#" class="top-right-img"/>
                </div>
              </div>
            </div>

            <div class="index-center-list phone-center-list" id="phoneSection5">
              <div class="center-list-top phone-list-left" @click="choiceType(5)">
                <div class="center-list-left">
                  <div class="center-list-icon">5</div>
                  <div class="list-left-font phone-left-font">{{lanType==1?'披露':'Disclosure'}}</div>
                </div>
                <div class="center-list-right">
                  <img src="@/images/xia.png" alt="#" class="list-right-icon phone-right-icon"/>
                </div>
              </div>
              <div class="center-list-center" v-if="type==5">
                <div class="list-center-top">
                  <div class="center-top-left">
                    <div class="top-left-title phone-left-title">{{lanType==1?'披露您的进度':'Disclosure progress'}}</div>

                    <div class="top-left-list">
                      <div class="left-list-li phone-list-li">
                        <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                        <div class="list-li-font phone-left-title">{{lanType==1?'您公司的目标被批准后，应每年披露公司的排放量，并监控实现目标的进度。':"Following approval, you should disclose your companies' emissions annually and monitor progress on reaching your target."}}</div>
                      </div>

                      <div class="left-list-li phone-list-li">
                        <img src="@/images/check-bullet.svg" alt="#" class="list-li-imgLeft"/>
                        <div class="list-li-font phone-left-title">{{lanType==1?'建议您公司的披露途径':'Recommendations for reporting include'}}<a href="http://cdp.net/">{{lanType==1?'包括CDP、':'disclosure through CDP,'}}</a>{{lanType==1?'年度报告、可持续发展报告和贵公司网站。':'annual reports, sustainability reports and your company’s website.'}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="center-top-right phone-top-right">
                  <img src="http://webadmin.wwfchina.org/storage/uploads/image/2021/01/13/02ad709d9e5ec57b65036b91729bc078.jpg" alt="#" class="top-right-img"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerBar ref="footerView"></footerBar>
  </div>
</template>

<script>
import tab from '@/components/tab'
import footerBar from '@/components/footerBar'
import axios from 'axios'
import { chunkArr } from '@/utils/util'
import config from '@/utils/config';
export default {
  name: 'chanceList',
  components: {
    tab:tab,
    footerBar:footerBar
  },
  data () {
    return {
      isShowWeb:config.urlList.isShowWeb,
      type:null,
      lanType:1
    }
  },
  methods:{
    fatherMethod(type){
      const vm=this
      vm.lanType=type
      setTimeout(()=>{
        vm.$refs.footerView.choiceType(type);
      },400)
    },
    choiceType(num){
      const vm=this
      if(vm.type==num){
        vm.type=null
      }else{
        vm.type=num
      }
    }
  },
  created () {
  },
  mounted(){
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
}
</script>
<style scoped>
.chance-list{

}

/**  pc 提示条样式  **/
.web-index-neck{
  font-size: 0.375rem;
  color: #000000;
  margin-top: 0.425rem;
  line-height: 1.6;
  position: relative;
  font-family:'wwf';
}
/* .web-index-neck::before{
  content: "";
  display: block;
  width: 0.75rem;
  height: 4px;
  background: #49bc9b;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
} */

.web-index-font{
  font-size: 0.125rem;
  color: #717171;
  letter-spacing: 2px;
  text-align: center;
  padding: 0.125rem 1.5rem 0;
  line-height: 1.6;
}
.web-index-label{
  margin: 0.25rem 0.5rem;
  height: auto;
  position: relative
}
.web-index-label::before{
  content: "";
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  top: 20px;
  background: #717171;
  z-index: 1;
}
.index-label-center{
  width: 100%;
  height: auto;
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.label-center-list{
  width: auto;
  height: auto;
  margin: 0 10px;
  cursor: pointer;
  position: relative;
  z-index: 2;
}
.center-list-icon{
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #333;
  font-size: 0.125rem;
  color: #333;
  text-align: center;
  line-height: 40px;
  background: #fff;
  display: block;
}
.center-list-font{
  font-size: 0.125rem;
  color: #333;
  line-height: 2;
  margin-top: 0.05rem;
}

.web-index-center{
  padding: 0.5rem;
  height: auto;
  width: 80%;
  margin: 0 auto;
}
.index-center-list{
  width: 100%;
  height: auto;
  min-height: 1.1875rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.center-list-top{
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.14rem;
  position: relative;
  margin-bottom: 0.125rem;
}
.center-list-top::before{
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg,#5d266d,#42a5ea);
}
.center-list-left{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
}
.list-left-font{
  margin-left: 0.1125rem;
  font-size: 0.225rem;
  color: #333;
  font-weight: 300;
}
.list-right-icon{
  width: 0.2rem;
  height: auto;
}

.center-list-center{
  width: 100%;
  height: auto;
}
.list-center-top{
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.center-top-left{
  flex: 2;
  height: auto;
  text-align: left;
}
.top-left-title{
  font-size: 0.125rem;
  color: #000;
}
.top-left-tips{
  font-size: 0.125rem;
  color: #000;
  margin-top: 0.125rem;
  font-style: italic;
}
.top-left-list{
  width: 100%;
  height: auto;
  margin-top: 0.125rem;
}
.left-list-li{
  width: 100%;
  height: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-top: 0.125rem;
}
.list-li-imgLeft{
  width: 31px;
  height: 31px;
  margin-right: 16px;
}
.list-li-font{
  font-size: 0.125rem;
}
.list-li-font a{
  vertical-align: inherit;
  text-decoration: underline !important;
  color:#333;
}

.center-top-right{
  width: 33.33%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.top-right-img{
  width: 60%;
  height: auto;
}

.list-center-bottom{
  margin-top: 0.5rem;
  width: 100%;
  height: auto;
}
.center-bottom-top{
  width: 100%;
  height: 0.32rem;
  border-bottom: 1px solid #919191;
  font-size: 0.125rem;
  text-align: left;
  line-height: 0.32rem;
}
.center-bottom-list{
  width: 100%;
  height: auto;
  padding-bottom: 0.25rem;
}
.center-bottom-list::after{
  content: "";
  display: block;
  clear: both;
}
.bottom-list-li{
  float: left;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 0.1rem;
  margin-right: 0.32rem;
  cursor: pointer;
}
.list-li-img{
  width: 0.125rem;
  height: 0.125rem;
  margin-right: 6px;
}
.list-li-font{
  font-size: 0.125rem;
  color: #333;
}
.mt{
  margin-top: 0.125rem;
}
.top-left-label{
  font-size: 0.125rem;
  color: #333;
  margin-top: 0.125rem;
}


/**  web最新动态  **/
.phone-index-neck{
  font-size: 0.72rem;
  font-weight: 500;
  color: #000000;
  margin-top: 4rem;
  line-height: 2;
  position: relative;
}
.phone-index-neck::before{
  content: "";
  display: block;
  width: 1.44rem;
  height: 4px;
  background: #cf6e32;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.phone-index-font{
  font-size: 0.32rem;
  padding: 0.5rem 0.8rem;
  color: #333;
}
.phone-label-center{
  position: fixed;
  top: 1.67rem;
  background: #fff;
  left: 0;
  right: 0;
  box-shadow: 0 6px 8px 0 rgb(0 0 0 / 6%);
  padding: 0.5rem 0;
  margin: 0;
}
.phone-label-center::before{
  top: 40px;
  content: "";
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  background: #717171;
  z-index: 1;
}
.phone-center-list{
  min-height: 2.4rem;
}
.phone-left-font{
  font-size: 0.52rem;
  margin-left: 0.28rem;
}
.phone-list-left{
  padding-bottom: 0.32rem;
}
.phone-right-icon{
  width: 0.48rem;
}
.phone-top-right{
  width: 80%;
  height: auto;
  margin: 0.8rem auto;
}
.phone-left-title{
  font-size: 0.4rem;
  line-height: 1.6;
}
.phone-li-img{
  width: 0.48rem;
  height: 0.48rem;
}
.phone-left-height{
  height: 0.8rem;
}
.phone-list-li{
  margin-top: 0.4rem;
}
.phone-mt{

}
</style>